<template>
  <expandable header="Witness Details" class="mb-10">
    <!-- Witness 1 (Required) -->
    <h6 class="mb-2">Witness 1 <span class="text-danger">*</span></h6>
    <b-row>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.witness_name"
          label="Witness Name"
          :disabled="isDisabled"
          @input="onInput"
          rules="required|max-150"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <select-field
          v-model.trim="form.witness_relation"
          label="Relation to Donor"
          :items="relationOptions"
          :disabled="isDisabled"
          @input="onInput"
          rules="required"
        ></select-field>
      </b-col>
      <b-col cols="12" md="4">
        <phone-field
          v-model.trim="form.witness_contact"
          label="Witness Contact Number"
          :disabled="isDisabled"
          @input="onInput"
          rules="required|integer"
        ></phone-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.witness_address"
          label="Witness Address"
          :disabled="isDisabled"
          @input="onInput"
          rules="max-250"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <file-input-group
          v-model.trim="form.witness_id_document"
          label="Witness ID Proof"
          :disabled="isDisabled"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          @input="onInput"
          rules="required|file-image-pdf|file-size"
        ></file-input-group>
      </b-col>
    </b-row>

    <!-- Witness 2 (Optional) -->
    <div class="mt-3" v-if="showWitness2">
      <h6 class="mb-2">Witness 2 (Optional)</h6>
      <b-row>
        <b-col cols="12" md="4">
          <input-field
            v-model.trim="form.witness_2_name"
            label="Witness 2 Name"
            :disabled="isDisabled"
            @input="onInput"
            rules="max-150"
          ></input-field>
        </b-col>
        <b-col cols="12" md="4">
          <select-field
            v-model.trim="form.witness_2_relation"
            label="Relation to Donor"
            :items="relationOptions"
            :disabled="isDisabled"
            @input="onInput"
          ></select-field>
        </b-col>
        <b-col cols="12" md="4">
          <phone-field
            v-model.trim="form.witness_2_contact"
            label="Witness 2 Contact Number"
            :disabled="isDisabled"
            @input="onInput"
            rules="integer"
          ></phone-field>
        </b-col>
        <b-col cols="12" md="4">
          <input-field
            v-model.trim="form.witness_2_address"
            label="Witness 2 Address"
            :disabled="isDisabled"
            @input="onInput"
            rules="max-250"
          ></input-field>
        </b-col>
        <b-col cols="12" md="4">
          <file-input-group
            v-model.trim="form.witness_2_id_document"
            label="Witness 2 ID Proof"
            :disabled="isDisabled"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            @input="onInput"
            rules="file-image-pdf|file-size"
          ></file-input-group>
        </b-col>
      </b-row>
    </div>
    <b-button
      v-if="!showWitness2 && !isDisabled"
      variant="outline-primary"
      size="sm"
      class="mt-2"
      @click="showWitness2 = true"
    >
      + Add Witness 2
    </b-button>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import FileInputGroup from "../../form/FileInputGroup.vue";
import PhoneField from "../../form/PhoneField.vue";
import SelectField from "../../form/SelectField.vue";
import { WITNESS_RELATIONS } from "../../../assets/constants/donor.constants";
export default {
  props: {
    value: {},
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    Expandable,
    FileInputGroup,
    PhoneField,
    SelectField,
  },
  data() {
    return {
      form: {},
      showWitness2: false,
      relationOptions: WITNESS_RELATIONS,
    };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
    // Auto-show witness 2 if data exists on edit
    if (
      this.form.witness_2_name ||
      this.form.witness_2_id_document ||
      this.form.witness_2_contact
    ) {
      this.showWitness2 = true;
    }
  },
};
</script>

<style></style>
